import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Categories from "../components/Categories";
import Shop from "../components/Shop";
import Safety from "../components/Safety";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import CheckoutModal from "../components/CheckoutModal";
import { fetchCategories } from "../lib/api";

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState(null);
  const [settings, setSettings] = useState({ address: "", phone: "", whatsapp: "", email: "" });

  useEffect(() => {
    fetchCategories()
      .then(setCategories)
      .catch(() => setCategories([]));
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`)
      .then((r) => r.json())
      .then(setSettings)
      .catch(() => {});
  }, []);

  return (
    <div className="relative min-h-screen bg-obsidian text-starlight">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Categories
          categories={categories}
          active={active}
          onPick={(slug) => {
            setActive(slug);
            const el = document.getElementById("shop");
            if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
            else if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
        />
        <Shop categories={categories} active={active} setActive={setActive} />
        <Safety />
      </main>
      <Footer categories={categories} settings={settings} />
      <CartDrawer />
      <CheckoutModal />
    </div>
  );
}
